// eslint-disable-next-line no-restricted-imports, monorepo/no-internal-import
import {useAbTestsFromTrailers} from '@aboutyou/data-fetcher/src/grpc/GrpcClientContext';
import {useCallback} from 'react';
import {AvailableBackendABTestNames} from '../../types';
import {rememberAbTestsActivatedBeforeCookieConsent} from '../abTestsActivatedBeforeCookieConsent';
import {useActivateAnyAbTestCallback} from './useActivateAbTestCallback';

/**
 * Activates an A/B test returned by an API
 */
export const useActivateApiAbTestCallback = <
  T extends AvailableBackendABTestNames,
>() => {
  const abTests = useAbTestsFromTrailers();
  const activate = useActivateAnyAbTestCallback();

  return useCallback(
    (experimentKey: T, config?: {triggerMultipleTimesPerSession?: boolean}) => {
      // keeps track of abTests that were activated before cookie consent in-memory so that we exclude them from the available AB Tests the user can participate in
      rememberAbTestsActivatedBeforeCookieConsent(experimentKey);

      if (abTests.includes(experimentKey)) {
        activate(experimentKey, config);
      }
    },
    [abTests, activate],
  );
};

export const useVariantActiveForAbTestBackend = <
  T extends AvailableBackendABTestNames,
>({
  experimentKey,
}: {
  experimentKey: T;
}) => {
  const abTests = useAbTestsFromTrailers();
  return abTests.includes(experimentKey);
};
